<ul class="stepper" [class.inline-icons]="numberOfSteps < 4">
  <ng-content select="cft-step"></ng-content>
</ul>
